import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import navara from "./../../../../assets/info/navara-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const NissanNavara = () => {
  useSmallNav("Nissan Navara");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Navara"} bolder />
        <InfoHero image={navara} />
        <InfoGrid>
          <div>
            <p>
              The Navara pickup D21 burst onto the scene in 1985 as both 2WD and
              4WD and gained a reputation as a reliable if somewhat basic and
              rugged work truck.
            </p>
            <p>
              The D22 arrived in 1997 and was much more refined but shared many
              mechanical parts from the previous D21.
            </p>
            <p>
              The biggest changed was the all new D40 series in 2005 showing
              that not only could you have the rugged and reliable nature now
              recognised with the Navara but also Luxury, Refinement and Style.
            </p>
            <p>
              Here at Pedders' Suspension, we not only supply replacement
              suspension parts, but we can also offer lift kits and suspension
              bushes to raise and tighten up the feel of your Navara.
            </p>
            <InfoHeader
              size="smaller"
              text={'The first question is "What do I want from my Navara?"'}
            />
            <p>
              If you're wanting to put your 4x4 to the test, lift the
              suspension, gain more axle articulation, fit bigger tyres etc,
              check out the "Lift Kits".
            </p>
            <p>
              If you constantly tow or load your Navara, an upgrade in standard
              height or lifted rear suspension will give you a more stable
              vehicle capable of taking more weight without suffering from
              suspension which is unable to control the vehicle.
            </p>
            <p>
              If you are a spirited driver, maybe you want to retain the
              standard height but stiffen everything up to give you more
              feedback, better handling characteristics and control. We cater
              for all.
            </p>
            <p>
              Please choose your vehicle from the selection and should you have
              any questions, feel free to ask us on our Live Chat.
            </p>
            <InfoHeader smaller text={"How high will my Navara be?"} />
            <p>
              Although the kits give an approximate lift, this can be a little
              misleading. Springs settle over time, so a 1.5 inch lift, may turn
              out to be a bit more in reality. To ensure that you know exactly
              what you are getting, we quote a fitted height. This is measured
              from the bottom of the wheel rim to the wheel-arch. The benefit of
              this method is that tyre choice has no influence on the quoted
              height. A summary of this can be seen here.
            </p>
            <p>
              Still not sure we have the right parts? Not sure which kit is the
              one for you? Then please get in touch, where one of our team will
              ensure you get the right parts for your needs.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Navara")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title={"Nissan Navara Video 1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/GW549IzY_98"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Navara Video 2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Navara Video 3"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Nissan" model="Navara" /> */}
      </Container>
    </section>
  );
};

export default NissanNavara;
